import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Card } from 'react-bootstrap'

import { Can } from '../../../_contexts/AbilitiesContext'

export default function TodaysFormsEmpty() {
  return (
    <Card style={{ border: '0px' }}>
      <Card.Body>
        <h5 className='font-weight-bold'>
          No Forms Due Today.
        </h5>
        <div className='my-4'>
          When you have Forms due they will appear here.
        </div>

        <Can I="send" a="form">
          <Button as={Link} to='/forms/schedule' variant='outline-primary' className="px-5">
            Send Form
          </Button>
        </Can>

      </Card.Body>
    </Card>
  )
}
